<template lang="pug">
  main#main.statically-about
    b-container(fluid)
      wc-breadcrumb(icon='fal fa-info-circle')
      section.l-section
        .l-section-h
          component(:is='locale')
</template>

<script>
import WcBreadcrumb from '@components/shared/WcBreadcrumb'

export default {
  name: 'statically-about',
  components: {
    WcBreadcrumb,
  },
  computed: {
    locale() {
      /* Reactivity computed by call actual locale. */
      this.$i18n.locale
      return () =>
        import(`@views/container/statically/about/${this.$wc.shared.locale}`).catch(() =>
          import(`@views/container/statically/about/${this.$wc.conf.base.default_locale}`)
        )
    },
  },
}
</script>
